import React from 'react';
import CustomSelect from '../../components/customSelect/CustomSelect';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import CustomInput from '../../components/customInput/CustomInput';
import CustomDatePicker from '../customDatePicker/CustomDatePicker';

const Form = () => {
  const [sku, setSku] = React.useState('');
  const [requestNumber, setRequestNumber] = React.useState('');
  const [status, setStatus] = React.useState('');
  const [promoStartDate, setPromoStartDate] = React.useState(null);
  const [promoEndDate, setPromoEndDate] = React.useState(null);

  const inputStyle = {
    width: '220px',
    height: '45px',
    marginBottom: '10px',
    marginRight: '10px',
    boxSizing: 'border-box',
    outline: 'none',
    paddingLeft: '25px',
    paddingRight: '5px',
  };

  const selectOptions = [
    { value: 'Option 1', label: 'Option 1' },
    { value: 'Option 2', label: 'Option 2' },
    { value: 'Option 3', label: 'Option 3' }
  ];

  return (
    <div style={{ display: 'flex', marginTop: '30px' }}>
      <div>
        <CustomInput
          type="text"
          placeholder="Enter SKU"
          value={sku}
          onChange={(e) => setSku(e.target.value)}
          style={inputStyle}
        />
      </div>
      <div>
        <CustomInput
          type="text"
          placeholder="Enter request number"
          value={requestNumber}
          onChange={(e) => setRequestNumber(e.target.value)}
          style={inputStyle}
        />
      </div>
      <div>
        <CustomSelect
          option={selectOptions}
          style={inputStyle}
          placeholder="Select a status"
        />
      </div>
      <div>
        <CustomDatePicker
          value={promoStartDate}
          onChange={(date) => setPromoStartDate(date)}
          placeholderText="Select Promo Start Date"
          showIcon
          style={inputStyle}
          dateFormat="yyyy-MM-dd"
          customInput={<input style={inputStyle} />}
          className="datepicker-right-icon"
        />
      </div>
      <div>
        <CustomDatePicker
          value={promoEndDate}
          onChange={(date) => setPromoEndDate(date)}
          placeholderText="Select Promo End Date"
          showIcon
          style={inputStyle}
          dateFormat="yyyy-MM-dd"
          customInput={<input style={inputStyle} />}
          className="datepicker-right-icon"
        />
      </div>
    </div>
  );
};

export default Form;    